import React from 'react'
import './fee.scss'
import { useTheme } from '../../../contexts/ThemeProvider';
import { LIGHT_THEME } from '../../../utils/constants';

const Fee = () => {
    const { theme } = useTheme();


    return (
        <>

            <section className='fee_bg'>

                <div className="custom-container fee_main">
                    <h3 className='about_common_heading'>
                        Fee Structure

                    </h3>
                    <p className='about_p'>
                        Rain has a transparent fee structure designed to reward key participants in each market. A 5% fee is collected from
                        the total volume of each resolved market and is distributed as follows:
                    </p>
                    {
                        theme != LIGHT_THEME ?
                            window.innerWidth > 991 ? (
                                <img src="/assets/about/stats.png" alt="stats" />) : (
                                <img src="/assets/about/stats-mb.png" alt="stats" />) :

                            window.innerWidth > 991 ? (
                                <img src="/assets/about/statslight.png" alt="stats" />
                            ) : (<img src="/assets/about/statslight-mb.png" alt="stats" />)
                    }
                    <p className='add_desc'>Market creators pay a flat $1 oracle fee, regardless of the market’s final volume.</p>
                </div>

            </section>

        </>
    )
}

export default Fee